export default __webpack_public_path__ + "static/15_35-2829cd942af545c4ace04ec83653c6ea.png";